import {
  BlockLabel,
  ButtonGhostCompact,
  CheckboxList,
  OKELink,
  SANS_0,
  SANS_3,
  TextInput,
  genTagComp,
  getBlockLabelProps,
} from "oolib";
import React, { Fragment } from "react";
import { convertTagDocsDataToOptions } from "../../../utils";
import { useGetQueryData } from "@/utils/react-query-hooks/general";

export default function Checkbox(props) {
  const {
    handleOnChange,
    id,
    fetchTagStatus,
    options,
    value,
    tagCategory,
    createTagText,
    setCreateTagText,
    handleCreateTag,
    tagCreateIsEnabled,
    createTagStatus,
    readOnly,
    invert,
    saveValueAsString,
    content,
  } = props;

  const { SELF_MANAGED_BASE_CONFIGS } = useGetQueryData('platformConfigs');

  const genDisplayComp = () => {
    if (!value) return null;
    return (
      <div className="OKE-Dropdown__tags-wrapper">
        {value.map((d) => genTagComp(id, d, { display: true, invert, theme: { SELF_MANAGED_BASE_CONFIGS }, usedOnContentType: content?.meta?.kp_content_type }))}
      </div>
    );
  };

  return readOnly ? (
    <div>
      <BlockLabel {...getBlockLabelProps(props)} />
  {  genDisplayComp()}
    </div>
  ) : (
    <Fragment>
      {fetchTagStatus === "loading" ? (
        <SANS_0>{"Loading..."}</SANS_0>
      ) : fetchTagStatus === "error" ? (
        <SANS_0>{"Error"}</SANS_0>
      ) : (
        fetchTagStatus === "success" && (
          <div>
            <CheckboxList
              {...props} //passing labels etc
              onChange={(k, v) => handleOnChange(k, v)}
              value={value}
              saveValueAsString={saveValueAsString}
              options={convertTagDocsDataToOptions(options, tagCategory)}
            />
            {tagCreateIsEnabled ? (
              <div style={{ paddingTop: "1rem" }}>
                {createTagText === undefined && (
                  <SANS_3>
                    <OKELink
                      text={"Add Other"}
                      icon="Plus"
                      onClick={() => setCreateTagText("")}
                    />
                  </SANS_3>
                )}
                {createTagText !== undefined && (
                  <div style={{ maxWidth: "32rem" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <SANS_3>{"Other, Please Specify"}</SANS_3>
                      <ButtonGhostCompact
                        
                        icon="X"
                        onClick={() => setCreateTagText(undefined)}
                      />
                    </div>
                    <TextInput
                      value={createTagText}
                      onChange={(k, v) => setCreateTagText(v)}
                      placeholder="Enter Tag Name"
                      // disabled={!!createTagText === false}
                      actionBtn={{
                        text:
                          createTagStatus === "loading" ? "Creating" : "Create",
                        onClick: handleCreateTag,
                        // disabled:  // prop disable is not working here
                        //   createTagStatus === "loading" ||
                        //   !!text === false,
                      }}
                    />
                  </div>
                )}
              </div>
            ) : null}
          </div>
        )
      )}
    </Fragment>
  );
}
